import { FilterValueType } from "../config/structured-search-schema";
import type { Filter } from "../config/types";

interface SerializedStructuredFilter {
  field: string;
  type: FilterValueType;
  operator: string;
  value: unknown;
  valueDisplay?: string;
  multiValueDisplay?: string[];
  nestedKey?: string;
  nestedKeyDisplay?: string;
}

const MIN_BETWEEN_VALUE_COUNT = 2;

const isValidBetweenValue = (value: unknown): boolean =>
  Array.isArray(value) && value.length >= MIN_BETWEEN_VALUE_COUNT;

const sanitizeStructuredFilters = (filters: Filter[]): Filter[] =>
  filters.filter(filter => {
    if (filter.operator !== "between") {
      return true;
    }

    return isValidBetweenValue(filter.value);
  });

export const serializeStructuredSearchFilters = (filters: Filter[]): string =>
  JSON.stringify(
    sanitizeStructuredFilters(filters).map(filter => ({
      field: filter.field,
      type: filter.type,
      operator: filter.operator,
      value: filter.value,
      valueDisplay: filter.valueDisplay,
      multiValueDisplay: filter.multiValueDisplay,
      nestedKey: filter.nestedKey,
      nestedKeyDisplay: filter.nestedKeyDisplay,
    })),
  );

export const deserializeStructuredSearchFilters = (raw: string): Filter[] => {
  try {
    const parsed = JSON.parse(raw) as SerializedStructuredFilter[];
    if (!Array.isArray(parsed)) {
      return [];
    }

    return sanitizeStructuredFilters(
      parsed.map(filter => ({
        id: crypto.randomUUID(),
        field: filter.field,
        type: filter.type,
        operator: filter.operator,
        value: filter.value as Filter["value"],
        valueDisplay: filter.valueDisplay,
        multiValueDisplay: filter.multiValueDisplay,
        nestedKey: filter.nestedKey,
        nestedKeyDisplay: filter.nestedKeyDisplay,
      })),
    );
  } catch {
    return [];
  }
};
